import { Typography } from '@mui/material';
import { VehiclePicture } from 'types/vehicles/types';

export interface PictureToDisplay {
  id: string;
  src: string;
  index: number;
  user: string;
  description: React.ReactElement;
  tab?: string;
  // eslint-disable-next-line camelcase
  is_cover: boolean;
}

export const parsePicturesToDisplay = (pictures: VehiclePicture[]): PictureToDisplay[] => {
  // Sort pictures: cover photo first, then by created timestamp (oldest to newest)
  const sortedPictures = [...pictures].sort((a, b) => {
    // If one is cover and the other isn't, cover comes first
    if (a.is_cover && !b.is_cover) return -1;
    if (!a.is_cover && b.is_cover) return 1;
    // Otherwise, sort by created timestamp
    return new Date(a.created).getTime() - new Date(b.created).getTime();
  });

  return sortedPictures.map((picture: VehiclePicture, index: number) => {
    return {
      id: picture.id,
      src: `${process.env.REACT_APP_MEDIA_API_URL}/${picture.picture}`,
      index,
      user: picture.user,
      tab: picture.tab,
      // eslint-disable-next-line camelcase
      is_cover: picture.is_cover,
      description: (
        <div
          style={{
            display: 'flex',
            gap: '20px',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '0 50px',
          }}
        >
          <Typography style={{ fontSize: '1.1rem', fontWeight: 'bold' }}>
            {new Date(picture.created).toLocaleString()}
          </Typography>
        </div>
      ),
    };
  });
};

export const createTemporaryPictureToDisplay = (file: File, index: number, userId: string): PictureToDisplay => {
  return {
    id: file.name,
    src: URL.createObjectURL(file),
    index,
    user: userId,
    // eslint-disable-next-line camelcase
    is_cover: false,
    description: <div></div>,
  };
};

export const reorderPicturesToFront = <T,>(items: T[], fromIndex: number): T[] => {
  const reordered = [...items];
  const [item] = reordered.splice(fromIndex, 1);
  reordered.unshift(item);
  return reordered;
};

export const removePicturesByIds = <T extends { id: string }>(items: T[], idsToRemove: Set<string>): T[] => {
  return items.filter(item => !idsToRemove.has(item.id));
};

export const getIndicesToRemove = <T extends { id: string }>(items: T[], idsToRemove: Set<string>): number[] => {
  return items.map((item, idx) => (idsToRemove.has(item.id) ? idx : -1)).filter(idx => idx !== -1);
};

export const calculatePagination = (totalItems: number, itemsPerPage: number, currentPage: number) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  return { totalPages, startIndex, endIndex };
};
